var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86603 14.5C8.48112 15.1667 7.51887 15.1667 7.13397 14.5L1.93782 5.5C1.55292 4.83333 2.03405 4 2.80385 4L13.1962 4C13.966 4 14.4471 4.83333 14.0622 5.5L8.86603 14.5Z",
    fill: "#363A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleArrow);
export default __webpack_public_path__ + "static/media/TriangleArrow.fbc8aa88444d3df66afbdf5a3adb1431.svg";
export { ForwardRef as ReactComponent };